import { IFilterDefinition } from '@df/catalog-ui/listing/listing';
import { ProductListing as CoreProductListing } from '@df/catalog-ui/listing/product-listing';
import { IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import cloneDeep from 'lodash-es/cloneDeep';
import { LocalListingSort } from '../../catalog/ui/listing/sort/local-listing-sort';
import { IN_STOCK_FILTER_ID } from './filter/stock/filter-stock';
export class ProductListing<T extends Product = Product<IProductDataV2>> extends CoreProductListing<T> {
    protected override createFilter(filterDef: IFilterDefinition): void {
        if (filterDef.source === IN_STOCK_FILTER_ID) {
            filterDef.type = 'stock';
        }
        super.createFilter(filterDef);
    }
    /**
     * overwrite core method to use local sort
     */
    override setSortOptions(options: IListingSortOption[]) {
        // we need to create deep copy here otherwise same object will be passed between categories (with optios marked as active)
        const sortOptions = cloneDeep(options);

        if (!this.sort) {
            this.setSort(new LocalListingSort<T>(this, sortOptions));
        } else {
            this.sort.setSortOptions(sortOptions);
        }
    }

    get length(): number {
        return this._models?.length || 0;
    }
}
